<div class="top-main-wrapper">
    <div class="dash-header">
        <div class="dash-title">
            <div class="p-field p-grid">
                <div class="p-col-6 p-md-6">
                    <button pButton pRipple icon="pi pi-arrow-left" label="Back to Tickets"
                        class="p-button p-button-options p-mr-2" (click)="goBack()"></button>
                    <h3 class="p-mt-2" *ngIf="ticket">Ticket #{{ ticket.id }} — {{ ticket.subject }}</h3>
                </div>
                <div class="p-col-6 p-md-6">
                    <button pButton pRipple icon="pi pi-refresh" label="Refresh"
                        class="p-button p-button-options pull-right" (click)="loadConversation(true)"></button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="main-inner" *ngIf="!loading && ticket; else loadingBlock">

    <p-message *ngIf="hasCustomerUpdate" severity="warn" text="Customer sent a new message. Review before replying."
        styleClass="p-mb-3">
    </p-message>

    <div class="p-grid">

        <!-- LEFT: Conversation -->
        <div class="p-col-12 p-md-8">
            <p-card>
                <ng-template pTemplate="header">
                    <div class="p-p-3">
                        <h4 class="p-mb-0">Conversation</h4>
                    </div>
                </ng-template>

                <div style="min-height: 200px;">
                    <ng-container *ngIf="conversation?.length; else emptyConversation">
                        <div *ngFor="let msg of conversation" class="p-mb-4"
                            [ngClass]="{'conversation-admin': msg.sender_type === 'admin', 'conversation-customer': msg.sender_type === 'customer'}">
                            <div class="p-d-flex p-ai-center p-mb-1">
                                <p-tag [value]="msg.sender_type === 'admin' ? 'Admin' : 'Customer'"
                                    [severity]="msg.sender_type === 'admin' ? 'info' : 'success'">
                                </p-tag>
                                <span *ngIf="msg.is_internal_note" class="p-ml-2">
                                    <p-tag value="Internal Note" severity="warning"></p-tag>
                                </span>
                                <span class="p-ml-2" style="font-size:0.8rem; color:#888;">
                                    {{ formatDate(msg.created_at) }}
                                </span>
                            </div>
                            <div class="p-p-3" style="background: #f8f9fa; border-radius: 6px; border-left: 3px solid"
                                [style.border-color]="msg.sender_type === 'admin' ? '#007bff' : '#28a745'">
                                <p class="p-m-0" style="white-space: pre-wrap;">{{ msg.message }}</p>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #emptyConversation>
                        <p class="p-text-center p-text-secondary p-p-4">No messages yet.</p>
                    </ng-template>
                </div>

                <!-- Reply form -->
                <ng-template pTemplate="footer">
                    <div class="p-field">
                        <div class="p-d-flex p-ai-center p-mb-2">
                            <label class="p-mr-3"><strong>New Reply</strong></label>
                            <p-toggleswitch [(ngModel)]="isInternalNote"></p-toggleswitch>
                            <span class="p-ml-2" style="font-size:0.85rem; color:#888;">
                                {{ isInternalNote ? 'Internal note (not visible to customer)' : 'Public reply' }}
                            </span>
                        </div>
                        <textarea pInputTextarea [autoResize]="true" rows="5" [(ngModel)]="replyMessage"
                            placeholder="Write your reply..." [style]="{width: '100%'}"></textarea>
                    </div>
                    <div class="p-field p-grid">
                        <div class="p-col-12 p-md-6">
                            <label>Change Status</label>
                            <p-select [options]="statusOptions" [(ngModel)]="ticketStatus" optionLabel="label"
                                optionValue="value" [style]="{width: '100%'}"></p-select>
                        </div>
                    </div>
                    <button pButton pRipple icon="pi pi-send"
                        [label]="isInternalNote ? 'Save Internal Note' : 'Send Reply'" class="p-button p-button-primary"
                        [disabled]="savingReply || !replyMessage.trim()" (click)="saveReply()">
                    </button>
                </ng-template>
            </p-card>
        </div>

        <!-- RIGHT: Ticket info -->
        <div class="p-col-12 p-md-4">
            <p-card>
                <ng-template pTemplate="header">
                    <div class="p-p-3">
                        <h4 class="p-mb-0">Ticket Info</h4>
                    </div>
                </ng-template>

                <div class="p-field">
                    <label>Status</label>
                    <div>
                        <p-tag [value]="ticket.status" [severity]="getStatusSeverity(ticket.status)"></p-tag>
                    </div>
                </div>

                <div class="p-field">
                    <label>Priority</label>
                    <div>
                        <p-tag [value]="ticket.priority || 'normal'"
                            [severity]="getPrioritySeverity(ticket.priority)"></p-tag>
                    </div>
                </div>

                <div class="p-field">
                    <label>Category</label>
                    <p>{{ ticket.category || '-' }}</p>
                </div>

                <div class="p-field">
                    <label>User</label>
                    <p class="p-mb-0">{{ ticket.name || 'N/A' }}</p>
                    <p class="p-mt-0" style="font-size: 0.85rem; color:#888;">{{ ticket.email || '' }}</p>
                </div>

                <div class="p-field">
                    <label>Created</label>
                    <p>{{ formatDate(ticket.created_at) }}</p>
                </div>

                <div class="p-field" *ngIf="ticket.closed_at">
                    <label>Closed</label>
                    <p>{{ formatDate(ticket.closed_at) }}</p>
                </div>

                <hr>

                <div class="p-field">
                    <label><strong>Original Message</strong></label>
                    <div class="p-p-3" style="background: #f8f9fa; border-radius: 6px; white-space: pre-wrap;">
                        {{ ticket.message }}
                    </div>
                </div>
            </p-card>
        </div>
    </div>
</div>

<ng-template #loadingBlock>
    <div class="main-inner p-text-center p-p-5" *ngIf="loading">
        <p>Loading ticket...</p>
    </div>
    <div class="main-inner p-p-5" *ngIf="!loading && error">
        <p-message severity="error" [text]="error"></p-message>
    </div>
</ng-template>

<p-toast key="ticketToast"></p-toast>